import { createSlice } from '@reduxjs/toolkit';

const referencesSlice = createSlice({
  name: 'references',
  initialState: {
    loading: false,
    success: false,
    failed: false,
    error: null,
    types: [],
    domains: [],
  },
  reducers: {
    fetchReferenceData(state) {
      state.loading = true;
      state.error = null;
    },
    referenceDataSuccess(state, { payload }) {
      state.loading = false;
      state.failed = false;
      state.success = true;
      state.types = payload.types;
      state.domains = payload.domains;
    },
    referenceDataError(state, { payload }) {
      state.loading = false;
      state.failed = true;
      state.error = payload;
    },
  },
});

export const { fetchReferenceData, referenceDataSuccess, referenceDataError } =
  referencesSlice.actions;

export default referencesSlice.reducer;
